module.exports = __webpack_public_path__ + "cd6f4ba66cb22d3716b8e25724cafb41.png";